export default {
  setWorkspaceFeedIsApproved(state, payload) {
    state.workspaceFeedIsApproved = payload;
  },
};
